import './footer.css'
import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

function Footer(){

    const [chinesename, setChineseName] = useState('');
    const [englishname, setEnglishName] = useState('');
    const [direction1, setDirection1] = useState('');
    const [direction2, setDirection2] = useState(''); 
    const [roadLoaded, setRoadLoaded] = useState(false);

    useEffect(() => {
        getRoadname();
    }, []);

    const getRoadname = async () => {
        try {
            const res = await fetch('https://api.sadatsunemyspace.uk/api/roadname', {
                method: 'POST',
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
            });

            const { data } = await res.json();
            data.map((road) => {
                setChineseName(road.name);
                setEnglishName(road.trans);
                setDirection1(road.direction);
                setDirection2(road.direction1);
            });

            setTimeout(() => setRoadLoaded(true), 100); // 轻微延迟再触发动画
        } catch (error) {
            console.error("Footer data load failed:", error);
        }
    }

    return (
        <div className='footer'>
            <div className='roadsign'>
                <center>
                    <motion.p 
                        className='chinesename'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: roadLoaded ? 1 : 0 }}
                        transition={{ duration: 1 }}
                    >
                        <center>
                            {chinesename}
                        </center>
                        
                        
                    </motion.p>
                    <motion.p 
                        className='englishname'
                        initial={{ opacity: 0 }}
                        animate={{ opacity: roadLoaded ? 1 : 0 }}
                        transition={{ duration: 1 }}
                    >
                        <center>
                            ◀&nbsp;{direction1}&nbsp;&nbsp;{englishname}&nbsp;&nbsp;{direction2}&nbsp;▶
                        </center>
                        
                    </motion.p>
                </center>
            </div>
            <div className='statementss'>
                <center>
                    <p>
                        Copyright © Me 2024-2025.
                        <br />
                        Unless otherwise specified, the content of this website adopts the&nbsp;
                        <a href="https://creativecommons.org/licenses/by-nc-sa/4.0/" target="_blank" rel="noopener noreferrer" style={{
                            color:'white'
                        }}>
                        CC BY-NC-SA 4.0</a> license.
                    </p>
                </center>
            </div>
        </div>
    );
}

export default Footer;
